import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_ANALYTICS: string = '[ecommerce analytics] Load Ecommerce Analytics';
export const LOAD_ECOMMERCE_ANALYTICS_SUCCESS: string = '[ecommerce analytics] Load Ecommerce Analytics Success';
export const LOAD_ECOMMERCE_ANALYTICS_FAIL: string = '[ecommerce analytics] Load Ecommerce Analytics Fail';

export class LoadEcommerceAnalytics implements Action {
  readonly type: string = LOAD_ECOMMERCE_ANALYTICS;

  constructor(public payload: { websiteId: number, datePicker: string, forceCharge?: boolean }) {
  }
}

export class LoadEcommerceAnalyticsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_ANALYTICS_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceAnalyticsFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_ANALYTICS_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceAnalyticsAction = LoadEcommerceAnalytics | LoadEcommerceAnalyticsSuccess | LoadEcommerceAnalyticsFail;
